module.exports = __webpack_public_path__ + "img/138.8.70b86504.png";